import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import GoOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/go.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  GoOverrideServerProperties,
  React
};